import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError, EMPTY } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ToastService } from './toast.service';

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
	constructor(
		public toastr: ToastService
	) { }

	intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		return next.handle(request)
		.pipe(
			catchError((error: HttpErrorResponse) => {
				if (error.status == 409) {
					this.toastr.info('Please refresh the page, then apply your changes before saving.  If the problem persists, contact IT.',
						'The data has changed since the page was loaded.', {
						disableTimeOut: true,
						closeButton: true,
						positionClass: 'toast-top-full-width'
					});
					return EMPTY;
				}
				return throwError(error);
			})
		)
	}
}